import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import * as studentsService from '../../services/students/studentsService';
import { classifyStudentsError, toCreateStudentPayload } from '../../services/students/studentsDto';
import { ChevronLeftIcon } from '../common/mdPageIcons';

export class AddAlumnos extends Component {
  static displayName = AddAlumnos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dni: '',
      name: '',
      showErrorMessage: false,
      success: false,
      errorMessage: '',
    };
  }

  async componentDidMount() {
    await constantClass.canAccess('WWAlumnos');
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.saveStudent();
    } else {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Los campos Documento y Nombre son obligatorios',
      });
    }
  };

  handleDNIChangeInput = (e) => {
    this.setState({ dni: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handleNameChangeInput = (e) => {
    this.setState({ name: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-alumnos" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-add-alumno">
        <Link className="md-page__back-link" to="/md-alumnos">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nuevo Alumno</h1>
        </div>
        <p className="md-page__subtitle">
          Complete los datos del alumno para registrarlo en el sistema.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="alumno-dni">
              Documento de Identidad
            </label>
            <input
              id="alumno-dni"
              className="md-page__field-input"
              name="dni"
              placeholder="Ingrese DNI"
              onChange={this.handleDNIChangeInput}
              disabled={loading}
              value={this.state.dni}
              required
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="alumno-nombre">
              Nombre Completo
            </label>
            <input
              id="alumno-nombre"
              className="md-page__field-input"
              name="name"
              placeholder="Ingrese Nombre Completo"
              onChange={this.handleNameChangeInput}
              disabled={loading}
              value={this.state.name}
              required
            />
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Guardar cambios
            </button>
          </div>
        </div>
      </div>
    );
  }

  isOkToSave() {
    return this.state.dni.length > 0 && this.state.name.length > 0;
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await studentsService.saveStudent(
        toCreateStudentPayload({ name: this.state.name, dni: this.state.dni })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyStudentsError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage, showErrorMessage: true });
    }
  }
}
